import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { emit, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span class="slex-choice-event-layer"><label class="slex-checkbox-field"><input type="checkbox" class="slex-checkbox"/> <span class="slex-checkbox-label"><!> <span> </span></span></label></span>`);

export default function Checkbox($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let checked = $.state(false);
	let lastHapticAt = 0;

	$.user_effect(() => bindPropStore($$props.props, (next) => {
		$.set(p, next, true);
		$.set(checked, !!(next.checked ?? next.value));
	}));

	function toggle(event) {
		if ($.get(p).disabled) return;

		$.set(checked, event.target.checked, true);
		emit($$props.ctx, "change", $.get(checked));
	}

	function vibrate(duration = 8) {
		if ($.get(p).haptic === false || $.get(p).haptics === false || $.get(p).disabled) return;

		const api = globalThis.navigator;

		if (api?.userActivation?.isActive === false) return;

		api?.vibrate?.(duration);
	}

	function haptic(duration = 8) {
		const now = Date.now();

		if (now - lastHapticAt < 80) return;

		lastHapticAt = now;
		vibrate(duration);
	}

	var span = root();
	var label = $.child(span);
	var input = $.child(label);

	$.remove_input_defaults(input);

	var span_1 = $.sibling(input, 2);
	var node = $.child(span_1);

	{
		var consequent = ($$anchor) => {
			InlineIcon($$anchor, {
				get name() {
					return $.get(p).icon;
				},
				className: 'slex-checkbox-icon'
			});
		};

		$.if(node, ($$render) => {
			if ($.get(p).icon) $$render(consequent);
		});
	}

	var span_2 = $.sibling(node, 2);
	var text_1 = $.child(span_2, true);

	$.reset(span_2);
	$.reset(span_1);
	$.reset(label);
	$.reset(span);

	$.template_effect(
		($0, $1) => {
			$.set_attribute(label, 'data-disabled', $.get(p).disabled ? "true" : undefined);
			input.disabled = !!$.get(p).disabled;
			$.set_attribute(input, 'data-state', $.get(checked) ? "checked" : "unchecked");
			$.set_attribute(input, 'aria-label', $0);
			$.set_text(text_1, $1);
		},
		[
			() => text($.get(p)["aria-label"] ?? $.get(p).ariaLabel ?? $.get(p).label) || undefined,
			() => text($.get(p).label)
		]
	);

	$.delegated('pointerdown', span, () => haptic(8));
	$.delegated('click', span, () => haptic(8));
	$.delegated('change', input, toggle);
	$.bind_checked(input, () => $.get(checked), ($$value) => $.set(checked, $$value));
	$.append($$anchor, span);
	$.pop();
}

$.delegate(['pointerdown', 'click', 'change']);